import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Card, CardBody, Input, Label } from "reactstrap";
import { withRouter, useHistory, RouteComponentProps } from "react-router-dom";

import { getAppConfigs, updateAppConfigs } from "../../store/actions";
import { AppConfigDto, State } from "../../interfaces";
import { ActivityButton, BreadCrumb } from "../../components/Common";
import { toast, ToastContainer } from "react-toastify";

type TProps = RouteComponentProps & {};
const EnableDisableComponent: React.FC<TProps> = () => {
  //#region hooks
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  //#endregion

  document.title = `${t("documentTitle", { pageName: "controlApp" })}`;

  //#region internal state
  const [configs, setConfigs] = useState<AppConfigDto[]>([]);
  //#endregion

  const {
    error: errorAppConfigs,
    response: dataAppConfigs,
    loading: isLoadingAppConfigs,
    success: isSuccessAppConfigs,
  } = useSelector(
    (state: any): State<AppConfigDto[]> => state.appConfigs.appConfigs
  );

  const {
    error: errorUpdateAppConfigs,
    loading: isLoadingUpdateAppConfigs,
    success: isSuccessUpdateAppConfigs,
  } = useSelector(
    (state: any): State<AppConfigDto[]> => state.appConfigs.updateAppConfigs
  );

  useEffect(() => {
    dispatch(getAppConfigs());
  }, []);

  useEffect(() => {
    if (!isLoadingAppConfigs && isSuccessAppConfigs && dataAppConfigs) {
      setConfigs(dataAppConfigs);
    }

    if (!isLoadingAppConfigs && errorAppConfigs) {
    }
  }, [isLoadingAppConfigs, isSuccessAppConfigs, errorAppConfigs]);

  const onChangeValue = (key: string, checked: boolean) => {
    let changedValues = configs.map((c) => {
      if (c.key === key) c.value = checked as any;
      return c;
    });
    setConfigs(changedValues);
  };

  const onSave = () => {
    dispatch(updateAppConfigs({ configs: configs }));
  };

  useEffect(() => {
    if (!isLoadingUpdateAppConfigs && isSuccessUpdateAppConfigs) {
      toast.success(t("savedSuccessfully"), {
        autoClose: 3000,
      });
    }
    if (!isLoadingUpdateAppConfigs && errorUpdateAppConfigs) {
      toast.success(errorAppConfigs, {
        autoClose: 3000,
      });
    }
  }, [
    isLoadingUpdateAppConfigs,
    isSuccessUpdateAppConfigs,
    errorUpdateAppConfigs,
  ]);

  return (
    <React.Fragment>
      <ToastContainer newestOnTop={true} />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("enableDisable")} pageTitle={t("controlApp")} />
          <Row>
            <Col xxl={12}>
              <Card>
                <CardBody>
                  <Row className="g-2">
                    {configs?.map((d) => {
                      return (
                        <Col lg={3}>
                          <div>
                            <div className="form-check mb-4 mt-2">
                              <Input
                                className="form-check-input"
                                type="checkbox"
                                id={d.key}
                                checked={/true/i.test(d.value)}
                                value={d.value}
                                onChange={({ target }) => {
                                  onChangeValue(d.key, target.checked);
                                }}
                              />
                              <Label
                                className="form-check-label"
                                htmlFor={d.key}
                              >
                                {t(d.key)}
                              </Label>
                            </div>
                          </div>
                        </Col>
                      );
                    })}

                    {/* <Col lg={3}>
                      <div>
                        <div className="form-check mb-4 mt-2">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            id="isAskAi"
                            value={isAskAI || false}
                            onChange={({ target }) => {
                              setIsAskAi(target.checked);
                            }}
                          />
                          <Label className="form-check-label" htmlFor="isAskAi">
                            {t("enableHomeworkSolution")}
                          </Label>
                        </div>
                      </div>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col lg={3}>
                      <ActivityButton
                        title="save"
                        inProgressTitle="saving"
                        color="success"
                        className="btn btn-success"
                        type="submit"
                        inProgress={isLoadingUpdateAppConfigs}
                        disabled={
                          isLoadingUpdateAppConfigs || isLoadingAppConfigs
                        }
                        onClick={onSave}
                      ></ActivityButton>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export const EnableDisablePage = withRouter(EnableDisableComponent);
